import { Route, Routes } from "react-router-dom";
import Console from "./console/ConsoleApp";
import Branch from "./branch/BranchApp";
import User from "./user/UserApp";
import ToastContainer from "./console/components/common/toastContainer";
import SystemPop from "./console/components/common/systemPop";
import React from "react";
import { IS_PORTAL_HOST } from "./branch/tenant";

function App() {
    return (
        <div>
            <Routes>
                {/* 지점 전용 도메인은 루트가 곧 포털이다. 콘솔/고객 사이트를 서비스하지 않는다 */}
                {IS_PORTAL_HOST ? (
                    <Route path="/*" element={<Branch />} />
                ) : (
                    <>
                        <Route path="/branch/*" element={<Branch />} />
                        <Route path="/console/*" element={<Console />} />
                        <Route path="/*" element={<User />} />
                    </>
                )}
            </Routes>
            <ToastContainer />
            <SystemPop />
        </div>
    );
}

export default App;
